import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { hasFeature, useAuth } from "@/context/AuthContext";

export function FeatureGate({ feature, children, title = "Recurso disponível em outro plano" }) {
  const { restaurant } = useAuth();
  const nav = useNavigate();
  const plan = restaurant?.plan || "free";
  if (hasFeature(plan, feature)) return children;
  return (
    <div className="rounded-2xl border-2 border-dashed border-stone-300 bg-stone-50/70 p-10 text-center" data-testid={`gate-${feature}`}>
      <div className="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-100 text-orange-600">
        <Lock className="h-6 w-6" />
      </div>
      <h3 className="font-display text-2xl font-bold text-stone-900">{title}</h3>
      <p className="mt-2 max-w-md mx-auto text-stone-600">
        Seu plano atual não inclui este recurso. Faça upgrade para desbloquear.
      </p>
      <Button className="mt-6 gap-2 bg-orange-600 hover:bg-orange-700" onClick={() => nav("/app/assinatura")} data-testid="gate-upgrade-btn">
        <Sparkles className="h-4 w-4" /> Ver planos
      </Button>
    </div>
  );
}
